import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=518e2af2"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports